import { datepickerValueToDate } from 'src/app/shared/functions/datepicker-value-to-date';
import {
  IChemicalExposureFormValue,
  IChemicalExposureRequest,
} from '../models/chemical-exposure.model';

export function mapChemicalExposureRequest(
  formValue: IChemicalExposureFormValue
): IChemicalExposureRequest {
  const request: IChemicalExposureRequest = {
    exposureDurationId: formValue.exposureDurationId,
    exposurePlacement: Number(formValue.exposurePlacement),
    exposureLocation: formValue.exposureLocation.trim(),
    safetyDataSheetConfirmed: formValue.safetyDataSheetConfirmed,
    exposedUserIds: formValue.exposedUserIds ?? [],
  };

  const substanceName = formValue.substanceName?.trim();
  if (substanceName) {
    request.substanceName = substanceName;
  }

  const manufacturerName = formValue.manufacturerName?.trim();
  if (manufacturerName) {
    request.manufacturerName = manufacturerName;
  }

  if (formValue.exposedAt) {
    request.exposedAt = datepickerValueToDate(formValue.exposedAt).toISOString();
  }

  return request;
}
